'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002414 from "./presto.-Groups-View$$anon$14.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002416 from "./presto.-Groups-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dGroup from "./presto.types$-Group.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dId$0024 from "./presto.types$-Group-Id$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$13() {
  this.aXi = null;
  this.aXa = null;
  this.aXb = false;
  this.aXj = null;
  this.aXk = false;
  this.aXn = null;
  this.aXg = null;
  this.aXh = false;
  this.aXc = null;
  this.aXd = false;
  this.aXe = null;
  this.aXf = false;
  this.aXl = false;
  this.aXm = false;
  this.aXi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aXn = "Group";
}
export { $c_Lpresto_GroupsView$$anon$13 as $c_Lpresto_GroupsView$$anon$13 };
$p = $c_Lpresto_GroupsView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$13;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$13() {
}
export { $h_Lpresto_GroupsView$$anon$13 as $h_Lpresto_GroupsView$$anon$13 };
$h_Lpresto_GroupsView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aXi;
});
$p.M = (function() {
  if ((!this.aXb)) {
    this.aXa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aXb = true;
  }
  return this.aXa;
});
$p.O = (function() {
  if ((!this.aXk)) {
    this.aXj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aXk = true;
  }
  return this.aXj;
});
$p.D = (function() {
  return this.aXn;
});
$p.t = (function() {
  if ((!this.aXh)) {
    this.aXg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aXh = true;
  }
  return this.aXg;
});
$p.N = (function() {
  if ((!this.aXd)) {
    this.aXc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dId$0024.$m_Lpresto_types$GroupId$().pb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().mm(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dGroups$002dView$0024$0024anon$002414.$c_Lpresto_GroupsView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aXd = true;
  }
  return this.aXc;
});
$p.Q = (function() {
  if ((!this.aXf)) {
    this.aXe = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), new $j_presto$002e$002dGroups$002dView$0024$0024anon$002416.$c_Lpresto_GroupsView$$anon$16());
    this.aXf = true;
  }
  return this.aXe;
});
$p.v = (function() {
  if ((!this.aXm)) {
    this.aXl = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), false);
    this.aXm = true;
  }
  return this.aXl;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee213) => ((p) => \u03b4scrutinee213.p8(p)))($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$())));
});
var $d_Lpresto_GroupsView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$13, "presto.GroupsView$$anon$13", ({
  JC: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$13 as $d_Lpresto_GroupsView$$anon$13 };
//# sourceMappingURL=presto.-Groups-View$$anon$13.js.map
